import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { EmploymentFormComponent } from './aban-tab/job-opportunities/employment-form/employment-form.component';
import { DisclaimerComponent } from './shared/components/disclaimer/disclaimer.component';
import { HomeComponent } from './home/home.component';

import { NlComponent } from './nl/nl.component';
import { RoshAdvComponent } from './rosh-adv/rosh-adv.component';
import { RoshdComponent } from './roshd/roshd.component';
import { SejamComponent } from './sejam/sejam.component';
import { FormSubmittedComponent } from './shared/components/form-submitted/form-submitted.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'request-ack',
    component: FormSubmittedComponent,
  },
  {
    path: 'aban',
    loadChildren: () =>
      import('./aban-tab/aban-tab.module').then((m) => m.AbanTabModule),
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./services/services.module').then((m) => m.ServicesModule),
  },
  {
    path: 'training',
    loadChildren: () =>
      import('./training/training.module').then((m) => m.TrainingModule),
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('./customers/customers.module').then((m) => m.CustomersModule),
  },

  {
    path: 'sejam',
    component: SejamComponent,
  },
  {
    path: 'disclaimer',
    component: DisclaimerComponent,
  },
  {
    path: 'nl',
    component: NlComponent,
  },
  {
    path: 'employment-form',
    component: EmploymentFormComponent,
  },
  {
    path: 'roshd',
    component: RoshdComponent,
  },
  {
    path: 'roshd1',
    component: RoshAdvComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
